<template>
  <div>
    <!-- <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="设备编号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.imeis"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="SIM卡号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.simCardNumber"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.deviceName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.celPhoneNumber"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">过期时间</span>
          <el-date-picker
            size="mini"
            v-model="expirationTime"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #devType="slotData">
        <p>{{ slotData.data.row.devType == 5 ? '行车记录仪' : '其他' }}</p>
      </template>
      <template #online="slotData">
        <p>{{ slotData.data.row.online == 51 ? '在线' : '离线' }}</p>
      </template>
      <template #photo="slotData">
        <el-image
          v-if="slotData.data.row.cardRotation"
          style="width: 100px; height: 50px"
          :src="slotData.data.row.cardRotation"
          :preview-src-list="[slotData.data.row.cardRotation]"
          :key="slotData.data.row.imei"
        >
          <div slot="error" class="image-slot" style="width: 100px; height: 50px">
            <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template>
    </e-table>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { filterObj } from '@/utils/util';
import { postAction } from "@/api/manage";
export default {
  name: "deviceList",
  components: { eTable },
  mixins: [listMixin],
  created() {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
    console.log("🚀 ~ mounted ~ this.dataSource:", this.dataSource)
  },
  computed: {},
  watch: {},
  data() {
    return {
      url: {
        list: "/carDev/getAllListV2",
      },
      queryParam: {},
      expirationTime: '',
      dateDefaultShow: "",
      columns: [
        {
          label: "设备类型",
          slotName: "devType",
          columnType: "slot",
        },
        {
          field: "title",
          label: "设备名称",
        },
        {
          field: "hardware",
          label: "设备型号",
        },
        {
          field: "imei",
          fixed: "left",
          label: "设备编号",
        },
        {
          field: "sn",
          label: "sn",
        },
        {
          field: "iccid",
          label: "iccid",
        },
        {
          field: "mac",
          label: "mac",
        },
        {
          label: "设备状态",
          slotName: "online",
          columnType: "slot",
        },
        {
          width: 200,
          label: "图片",
          slotName: "photo",
          columnType: "slot",
        },
      ],
      deviceList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    dateChange(date) {
      if (date) {
        this.queryParam.startTime = date[0] + " 00:00:00";
        this.queryParam.endTime = date[1] + " 00:00:00";
      } else {
        this.queryParam.startTime = "";
        this.queryParam.endTime = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.expirationTime = "";
      this.searchQuery();
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();
      this.loading = true;
        postAction(this.url.list, params).then((res) => {
          if (res.msg) {
            this.$message.warning(res.msg);
            return;
          }
          this.dataSource = res.data
          console.log("🚀 ~ postAction ~ res.data.records:", res.data.records)
          if (res.data.total) {
            this.ipagination.total = res.data.total;
          } else {
            this.ipagination.total = 0;
          }
          this.loading = false;
        });
    },
    getQueryParams() {
      var param = Object.assign(this.queryParam, this.isorter, this.filters);
      param.page = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
